import { styled } from '@uhg-abyss/web/tools/styled';
import { Toggle } from '@uhg-abyss/web/ui/Toggle';

export const TextContainer = styled('div', {
  color: '$core.color.brand.100',
  paddingTop: '5px',
  paddingLeft: '0px',
});

export const BrowseAllTextContainer = styled('div', {
  color: '$core.color.brand.100',
  paddingLeft: '0px',
});

export const ChipContainer = styled('div', {
  color: 'white',
  marginTop: '10px',
  paddingLeft: '16px',
  paddingRight: '16px',
});

export const ToggleSwitchStyled = styled(Toggle, {
  '& .abyss-toggle-container': {
    marginBottom: '$sm',
  },
  '& .abyss-label-element': {
    marginBottom: '$sm',
    fontSize: '$sm',
    fontWeight: '$medium',
    '& .voice-only-label-text': {
      border: '0',
      clip: 'rect(0 0 0 0)',
      height: '1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      userSelect: 'none',
      width: '1px',
    },
  },
  '& .abyss-toggle-input': {
    backgroundColor: '$core.color.neutral.60',
  },
  '& .abyss-toggle-thumb': {
    backgroundColor: 'white',
  },
});

export const ParagraphCont = styled('p', {
  fontSize: '14.22px',
  lineHeight: '20px',
  fontWeight: '$medium',
  color: '#373D3F',
});

export const letterBadgeStyles = {
  'abyss-badge-root': {
    width: '32px',
    height: '32px',
    borderRadius: '999px',
    marginTop: '$md',
    marginBottom: '12px',
  },
  'abyss-badge-content': {
    fontWeight: '600',
    lineHeight: '16px',
    fontSize: '14.22px',
  },
};

export const linkStyles = {
  'abyss-link-root': {
    lineHeight: '20px',
    marginBottom: '12px',
    fontWeight: '600',
    textAlign: 'left',
  },
};

export const discriptionStyle = {
  'abyss-text-root': {
    marginBottom: '$sm',
    fontSize: '$sm',
    fontWeight: '$medium',
  },
};

export const DisabledLink = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  lineHeight: '20px',
  marginBottom: '12px',
  fontWeight: '600',
  textAlign: 'left',
  '& .abyss-text-root': {
    color: '$core.color.neutral.80',
  },
});

export const SearchCount = styled('span', {
  color: '$core.color.neutral.90',
  fontWeight: 700,
  fontSize: '$md',
  marginBottom: '$md',
});

export const HeadingDescriptionStyle = styled('p', {
  marginBottom: '$sm',
  fontSize: '18px',
  fontWeight: '400',
  lineHeight: '20px',
  color: '#4B4D4F',
});

export const clearStyles = {
  'abyss-button-root': {
    height: '43px',
    border: '0px solid #D0F1F5',
    width: '80px',
    backgroundColor: '$core.color.neutral.0',
    fontWeight: 'bold',
    color: '$core.color.brand.60',
    margin: '0px',
    marginTop: '$sm',
    cursor: 'pointer',
    justifyContent: 'center',
    lineHeight: '$sm',
    overflow: 'hidden',
    span: {
      color: '$uhcPrimary1 !important',
    },
    '&:hover': {
      backgroundColor: '#EEF8FB',
    },
    '&:focus, &.active, &:hover:focus, &:focus-within': {
      backgroundColor: '#D0F1F5',
    },
    textAlign: 'center',
  },
  'abyss-chip-text': {
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '600',
  },
  'abyss-button-content-container': {
    span: {
      width: '53px',
    },
  },
};
